import React from 'react';
import styled from 'styled-components';

interface SwitchItem {
    icon?: React.ReactNode;
    label: string;
    value: string;
}
interface SwitchSelectProps {
    items: SwitchItem[];
    onChange: (value: string) => void;
    value: string;
    theme: { bg: string; themeName?: string };
}
export const SwitchSelect = ({ items, onChange, value, theme }: SwitchSelectProps) => {
    const selectedIndex = items.findIndex((i) => i.value === value);
    return (
        <SwitchSelectWrapper className='SwitchSelect' selectedItemColor={theme.themeName === 'dark' ? '#fff' : ''}>
            <div style={{ width: `calc(100%)`, display: 'flex', flexDirection: 'row', position: 'relative' }}>
                <SelectedIndicator style={{ left: `calc(${selectedIndex} * (100%/${items.length}))`, background: theme.bg }} />
                {items.map((item) => (
                    <div key={item.value} className={['item', item.value === value ? 'selected' : ''].join(' ')} onClick={() => onChange(item.value)}>
                        {item.icon}
                        {item.label}
                    </div>
                ))}
            </div>
        </SwitchSelectWrapper>
    );
};

const SelectedIndicator = styled.div`
    border-radius: 100px;
    position: absolute;
    left: 0px;
    width: 50%;
    height: 34px;
    z-index: 5;
    transition: left 0.2s ease;
`;

const SwitchSelectWrapper = styled.div<{ selectedItemColor: string }>`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 30px;
    padding: 2px;
    background-color: #cdcdcd;

    .item {
        z-index: 6;
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        height: 34px;
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #172344;
        transition: color 0.2s ease;
        :hover {
            cursor: pointer;
        }
    }
    .item.selected {
        color: ${({ selectedItemColor }) => selectedItemColor};
    }
`;
